// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { AppUtils } from '@gscope-mfe/app-bridge';
import React from 'react';
import _ from 'lodash';

const DEBOUNCE_WAIT = 150;
const DEBOUNCE_MAX_WAIT = DEBOUNCE_WAIT * 3;
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
export function withAppUtils(WrappedComponent) {
    const WithAppUtils = function (props = {}) {
        const [utils, setUtils] = React.useState(null);
        React.useEffect(() => {
            const debouncedListener = _.debounce(
                (_utils) => {
                    if (_utils) {
                        setUtils(_utils);
                    }
                },
                DEBOUNCE_WAIT,
                {
                    maxWait: DEBOUNCE_MAX_WAIT,
                },
            );
            const token = AppUtils.subscribe(debouncedListener);
            return () => {
                AppUtils.unsubscribe(token);
                debouncedListener.cancel();
            };
        }, []);
        return <WrappedComponent {...props} appUtils={utils} />;
    };
    WithAppUtils.displayName = `WithAppUtils(${getDisplayName(WrappedComponent)})`;
    return WithAppUtils;
}
